import { AlertBanner, Css, Responsive } from '@/ui';
import styled from '@emotion/styled';
import AlertBannerIcon from './AlertBannerIcon';
import { QuickLink } from '../common/quick-links/QuickLink';
import { IExternalLinkEntry, IInternalLinkEntry } from '../../contentful';
import { getUrlForInternalLink } from '../../utils/getUrlForLink';
import { useCommonData } from '../../common-data/useCommonData';

interface IAlertBanners {
	title: string;
	body: string;
	link?: IExternalLinkEntry | IInternalLinkEntry;
}

export function AlertBanners({ title, body, link }: IAlertBanners) {
	const { pathToPageIdMap } = useCommonData();
	const linkType =
		link?.contentType === 'external-link' ? 'externalSecondary' : 'internal';

	return (
		<AlertBanner title={title} alertIcon={<AlertBannerIcon />}>
			<AlertBodyWrap>
				<AlertBannerBody aria-label={body}>{body}</AlertBannerBody>
				{link && (
					<QuickLink
						type={linkType}
						label="Read more"
						url={
							link.contentType === 'external-link'
								? link.fields.url
								: getUrlForInternalLink(link, pathToPageIdMap)
						}
					/>
				)}
			</AlertBodyWrap>
		</AlertBanner>
	);
}

const AlertBodyWrap = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	gap: ${Css.pxToRem(16)};
	line-height: ${Css.pxToRem(22)};

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		flex-direction: column;

		a {
			padding: 0;
		}
	}
`;

const AlertBannerBody = styled.p`
	margin-left: 3.1em;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-left: 0;
	}
`;
